/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Search_In_FolderInputs */

const cs_documents_search_in_folder = /** @type {(inputs: Documents_Search_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V této složce`)
};

const en_documents_search_in_folder = /** @type {(inputs: Documents_Search_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In this folder`)
};

/**
* | output |
* | --- |
* | "In this folder" |
*
* @param {Documents_Search_In_FolderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_search_in_folder = /** @type {((inputs?: Documents_Search_In_FolderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Search_In_FolderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_search_in_folder(inputs)
	return cs_documents_search_in_folder(inputs)
});